import { DripEmailReportInfo } from '../types';
import axiosInstance from './axiosInstance';

export async function getDripEmailReport(uuid: string) {
  const response = await axiosInstance.get(`/drip/emails/${uuid}/report`);
  return response.data as DripEmailReportInfo;
}
